<template>
  <ul class="list-inline mb-2 d-xl-block d-none">
    <li class="me-4">
      <span class="d-inline-block align-middle bg-s01 px-3 py-2 mb-1 me-1"></span>
      配車
    </li>
    <li class="me-4">
      <span class="d-inline-block align-middle bg-s02 px-3 py-2 mb-1 me-1"></span>
      回収
    </li>
    <li class="me-4">
      <span class="d-inline-block align-middle bg-s03 px-3 py-2 mb-1 me-1"></span>
      レッカー
    </li>
    <li class="me-4">
      <span class="d-inline-block align-middle bg-s04 px-3 py-2 mb-1 me-1"></span>
      点検・車検・修理・輸送
    </li>
    <li>
      <span class="d-inline-block align-middle bg-s05 px-3 py-2 mb-1 me-1"></span>
      その他
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  setup() {
    return {};
  },
});
</script>
